const singleBabyCongratsData = {
    0: {
      subtext: "[0~2주차] 새 생명의 시작, 함께 시작하는 여정\n\n👩🏻엄마의 몸은 착상을 위한 호르몬 변화로 감기같은 증상이 느껴질 수 있어요. 엽산과 비타민D 같은 필수 영양소도 미리 챙기면 좋아요.\n\n👨🏻아빠도 건강한 정자 준비를 시작할 때랍니다.\n\n함께 만드는 생명의 첫걸음, 지금부터 천천히 준비해요."
    },
    1: {
      subtext: "[0~2주차] 새 생명의 시작, 함께 시작하는 여정\n\n👩🏻엄마의 몸은 착상을 위한 호르몬 변화로 감기같은 증상이 느껴질 수 있어요. 엽산과 비타민D 같은 필수 영양소도 미리 챙기면 좋아요.\n\n👨🏻아빠도 건강한 정자 준비를 시작할 때랍니다.\n\n함께 만드는 생명의 첫걸음, 지금부터 천천히 준비해요."
    },
    2: {
      subtext: "[0~2주차] 새 생명의 시작, 함께 시작하는 여정\n\n👩🏻엄마의 몸은 착상을 위한 호르몬 변화로 감기같은 증상이 느껴질 수 있어요. 엽산과 비타민D 같은 필수 영양소도 미리 챙기면 좋아요.\n\n👨🏻아빠도 건강한 정자 준비를 시작할 때랍니다.\n\n함께 만드는 생명의 첫걸음, 지금부터 천천히 준비해요."
    },
    3: {
      subtext: "[3주차] 조용히 착상 중, 생명이 자리 잡아요\n\n👶🏻자궁에 착상한 아기는 빠르게 세포분열을 시작하며 성장 중이에요.\n\n👩🏻엄마는 미열, 유방통, 피로, 이른 입덧, 예민한 후각 등 초기 증상이 나타날 수 있어요. 엽산, 단백질, 철분, 칼슘을 충분히 섭취하고 감기약이나 술은 피하세요.\n\n👨🏻아빠도 금연·금주를 실천하며 함께 준비해요."
    },
    4: {
      subtext: "[4주차] 임신 확정! 생명이 자리잡는 기관 형성기\n\n착상이 완료되며 임신 테스트 결과가 양성으로 나와요!\n\n아기는 눈·심장·신경 등 기관을 만들기 시작하고, 엄마는 착상혈·피로·빈뇨·입덧을 경험할 수 있어요.\n\n약물·X선은 의사 상담 후에! 두 사람의 든든한 준비가 아기의 건강을 지켜줄 거예요.🌸"
    },
    5: {
      subtext: "[5주차] 조심 또 조심, 임신 5주차 시작!\n\n입덧, 후각 예민, 피로, 기분 기복 등 임신 증상이 본격화돼요.\n\n💊임신 사실을 몰랐던 약 복용은 대부분 큰 문제가 되지 않지만, 걱정된다면 병원 상담이 우선이에요.\n\n무리한 운동과 스트레스는 피하세요. 작은 변화 하나하나가 새로운 생명의 징후랍니다.😊"
    },
    6: {
      subtext: "[6주차] 콩알만 한 아기와 호르몬 대소동!\n\n입덧·빈뇨·기분 기복 등 호르몬 변화로 몸과 마음이 요동치는 시기예요.\n\n😣 물을 자주 마시고, 감정 변화엔 스스로에게 너그러이 대해주세요.\n\n아빠는 병원 일정을 미리 확인하고 진료에 꼭 동행해 주세요. 짧은 말 한마디, 따뜻한 손길이 아내에게 큰 위로가 된답니다.😘"
    },
    7: {
      subtext: "[7주차] 입덧이 심해지고 감정도 예민해져요.\n\n아직 배는 티 나지 않지만 몸속 변화는 활발해요. 입덧, 변비, 가슴 통증은 흔한 증상! 물을 자주 마시고 식사는 조금씩 자주 하세요.\n\n아빠는 집안일을 분담하고, 냄새 나는 음식물 처리는 꼭 맡아주세요!☺"
    },
    8: {
      subtext: "[8주차] 자궁도 커지고, 아기도 빠르게 성장 중이에요!\n\n입덧은 심해지고 속은 울렁거리지만, 조금씩 자주 드세요.\n\n분비물 증가는 정상! 하지만 냄새·가려움이 심하면 병원에 꼭 방문하세요.\n\n👨🏻아빠는 이젠 '임신 가정'의 일원!\n작은 집안일부터 함께 나누는 연습을 시작해 보세요."
    },
    9: {
      subtext: "[9주차] 쉽게 짜증나고 피곤해지는 시기예요!\n\n호르몬 변화로 감정 기복이 심하고 입덧도 고비를 지나고 있어요. 무리하지 말고 충분히 쉬세요.\n믿을 수 있는 사람에게 마음을 나누는 것도 좋아요.😊\n\n👨🏻아빠는 아내의 작은 말과 표정에 더 귀 기울여주세요. 함께하는 공감이 큰 위로가 돼요."
    },
    10: {
      subtext: "[10주차] 입덧 최고조, 조금만 더 힘내요!\n\n입덧은 곧 잦아들어요. 지금은 물을 자주 마시고, 먹고 싶은 음식만 조금씩 자주 섭취해요.\n아랫배 통증과 늘어난 핏줄은 자연스러운 변화랍니다.\n\n아빠는 국민행복카드 신청 등 의료비 지원도 함께 챙겨주세요."
    },
    11: {
      subtext: "[11주차] 엄마의 혈액량이 늘었어요!\n\n자궁이 커지며 혈류도 증가해 어지럼증이나 빈혈이 나타날 수 있어요. 철분이 풍부한 음식과 보충제를 꼭 챙기세요.\n\n질 분비물 증가도 자연스러운 변화예요. 통풍 잘 되는 옷과 위생 관리로 불편함을 줄여보세요.🎈"
    },
    12: {
      subtext: "[12주차] 자궁이 자몽만큼 커졌어요!\n\n자궁이 골반 밖으로 나와 아랫배가 살짝 볼록해졌어요. 방광 압박으로 소변이 잦고, 인대가 당기며 아랫배 통증도 생겨요.\n\n1차 기형아 검사 시기예요. 검사는 간단하니 편한 마음으로 받아보세요.\n\n👨🏻아빠의 따뜻한 격려 한마디가 아내에게 큰 힘이 돼요!"
    },
    13: {
      subtext: "[13주차] 입덧이 줄고 입맛이 돌아와요!\n\n식욕이 늘며 과식하기 쉬운 시기! 영양 밸런스가 중요하니 체중은 주당 500g, 월 2kg 이하로 조절해요. 눈 건조, 임신선은 자연스러운 변화지만 자극은 피하세요.\n\n이제는 임신 소식을 주변에 전해도 좋은 때랍니다. 🍀"
    },
    14: {
      subtext: "[14주] 배가 조금씩 불러와요, 새로운 전환점!\n\n자궁이 커지며 아랫배가 볼록해지고 엄마와 아기는 탯줄로 단단히 연결돼요. 피부색 변화나 트러블은 일시적이니 걱정 마세요.\n\n튼살은 지금부터 예방을! 아빠는 보습과 마사지를 통해 아내와 아기에게 따뜻한 마음도 함께 전해보세요.😘"
    },
    15: {
      subtext: "[15주차] 몸이 변화하는 만큼, 마음도 챙겨야 할 때!\n\n아랫배가 도드라지고 체중이 늘며 본격적인 D라인이 시작됐어요. 잇몸이 약해질 수 있으니 구강 건강도 챙기며 2차 기형아검사도 준비하세요.\n\n남편과 서로의 감정을 솔직히 나누는 시간도 꼭 가져보세요. 건강한 임신은 함께 만드는 것이랍니다.☺"
    },
    16: {
      subtext: "[16주차] 안정기, 그래도 조심! 아기는 계속 자라고 있어요.\n\n입덧은 물러가고 배는 도드라지기 시작해요. 자궁이 커지며 허리 통증이 생길 수 있으니 바른 자세와 스트레칭을 해주세요.\n\n성관계는 가능하지만 배를 누르지 말고 콘돔 사용과 위생을 꼭 지켜주세요. 배려하는 마음이 가족을 더 가깝게 해줘요.🤗"
    },
    17: {
      subtext: "[17주차] 조심스레 느껴지는 태동, 작은 기적의 시작이에요.\n\n🫧물이 뽀글거리는 느낌, 장이 꾸르륵하는 느낌이 있다면 첫 태동일 수 있어요. 식욕이 돌아오며 체중이 급격히 늘 수 있어요. 철분과 섬유소를 챙기고, 변비 예방도 잊지 마세요.\n\n검사 일정 많아지는 시기, 배우자의 세심한 배려가 큰 힘이 됩니다.🌹"
    },
    18: {
      subtext: "[18주차] 아기가 움직이는 것을 느끼기 시작해요!\n\n본격적인 태동이 시작돼요!🎉\n질 분비물과 유방 변화는 자연스러운 증상이지만, 악취·가려움이 있으면 진료가 필요합니다.\n\n아빠 목소리는 아기에게 닿는 가장 따뜻한 음악이에요. 지금부터 아기에게 말을 걸어보세요. 태명으로 불러주면 더 좋아요!🐥"
    },
    19: {
      subtext: "[19주차] 조용한 변화들, 아기의 준비도 계속돼요.\n\n유두가 짙어지고 유즙이 나올 수 있어요. 임신 후 코골이나 수면무호흡이 생기면 전문 진료를 받아보세요.🩺\n\n태아는 간뇌가 발달해 감정을 느껴요.\n엄마가 편안해야 아기도 편안하니, 아빠는 아내를 웃게 해주는 하루로 만들어주세요.🍀"
    },
    20: {
      subtext: "[20주차] 절반을 지나온 여정, 몸도 감정도 변화 중이에요.\n\n다리 붓기와 하지정맥류가 나타날 수 있어요. 가벼운 걷기, 다리 올리기, 압박스타킹이 도움돼요.\n\n정밀 초음파로 아기 얼굴을 볼 수 있는 시기예요! 아기와의 첫 만남, 함께 감동의 순간을 기록해보세요.🩷"
    },
    21: {
      subtext: "[21주차] 숨이 차고 배가 뭉쳐요.\n\n자궁이 커지며 폐를 눌러 숨이 차고, 불규칙한 배뭉침도 느껴질 수 있어요. 무리한 활동은 피하고, 자주 쉬어주세요.\n\n🍀임신 중 불안한 감정은 누구나 겪는 자연스러운 일이에요. 남편의 따뜻한 말 한마디가 큰 힘이 됩니다. \"잘하고 있어💗\" 한마디로 마음을 나눠주세요."
    },
    22: {
      subtext: "[22주차] 몸이 둔해지고 자주 넘어진다면 조심!\n\n🤰🏻배가 불러오며 중심 잡기가 어려워지고, 요통도 생기기 쉬워요. 편한 신발을 신고, 계단이나 미끄러운 곳은 특히 조심하세요.\n\n지금은 넘어지지 않도록 '천천히'가 가장 중요한 시기예요. 여유롭고 편안한 마음을 가지세요.🎈"
    },
    23: {
      subtext: "[23주차] 임신 중 치질과 가려움, 흔한 변화예요.\n\n변비로 인해 치질이 생기기 쉬운 시기예요. 섬유질과 수분 섭취, 좌욕이 도움돼요.\n\n짧은 태교여행도 정서에 큰 도움이 된답니다. 무리 없는 외출로 기분 전환해보세요.🤗"
    },
    24: {
      subtext: "[24주차] 무거워진 몸, 섬세한 관리가 필요해요.\n\n이제 임신성 당뇨 검사 시기예요. 체중 조절과 건강한 식단, 주기적인 운동으로 임신성 당뇨를 예방하세요.👟\n\n다리에 쥐도 나고 잇몸 출혈도 나타나는 등, 몸이 불편해진 엄마에게 아빠의 작은 손길이 큰 위로가 되는 시기입니다."
    },
    25: {
      subtext: "[25주차] 자궁이 많이 커지는 시기, 몸을 편하게 해주세요.\n\n자궁이 위를 눌러 숨이 차고 소화도 더뎌져요. 자극적인 음식은 피하고 조금씩 자주 식사하세요.\n눈이 건조하다면, 인공눈물이나 당근 섭취도 도움돼요.\n\n👶🏻부부가 함께 아기 이름을 고민하며, 매일 따뜻한 목소리로 아기에게 사랑을 전해보세요."
    },
    26: {
      subtext: "[26주차] 예민해진 몸과 마음을 다독여 주세요.\n\n자궁이 커지며 갈비뼈 통증, 소화불량, 요통이 나타날 수 있어요.\n바른 자세, 가벼운 스트레칭이 큰 도움이 돼요.\n\n태아도 이제 엄마의 감정을 느낄 수 있어요. 마음을 안정시키고 긍정적인 생각을 많이 하세요🌸"
    },
    27: {
      subtext: "[27주차] 임신 중기가 끝나가요!\n\n다리가 붓고 저리는 증상이 잦아져요. 쥐가 날 땐 마사지로 혈액순환을 도와주세요.\n\n체중 급증·손발 부종·두통이 있다면 임신중독증 징후일 수 있으니 반드시 담당의와 상의하세요.🩺"
    },
    28: {
      subtext: "[28주차] 임신 후기 시작! 출산 대비 계획을 세워봐요.\n\n유방에서 초유가 만들어지기 시작하고, 빠르면 초유가 흘러나올 수도 있어요.\n\n임신 중 건망증은 자연스러운 현상이니 너무 스트레스 받지 마세요. 모든 걸 혼자 해결하려 하지 않아도 괜찮아요.🙂"
    },
    29: {
      subtext: "[29주차] 검진 간격이 짧아졌어요! 출산 준비, 이제 시작해요.\n\n이제부터는 2주마다 정기검진을 받아요. 태동이 강해지며 갈비뼈 통증도 느껴지고, 분비물 증가로 외음부 가려움이 생기기도 해요.😣\n\n👨🏻아빠도 검진에 함께하며 출산 교실 참여 등 본격적인 출산 준비를 시작해보세요."
    },
    30: {
      subtext: "[30주차] 출산 준비물은 미리 챙겨두세요!\n\n자궁이 명치 아래까지 자라 위와 심장을 눌러 숨이 차고 속도 쓰려요. 가벼운 산책이나 임산부 요가를 추천드립니다.\n\n출산 준비물과 절차, 산후계획은 여유 있을 때부터 차근차근 정리해두는 게 좋아요.\n\n아빠는 각종 출산 지원제도와 서류를 미리 챙겨주세요.📜"
    },
    31: {
      subtext: "[31주차] 빠르게 늘어나는 체중, 여러 불편함이 생겨요.\n\n무거운 배와 커진 유방으로 요통·어깨 결림이 심해져요. 임산부 체조, 수영, 마사지로 통증을 완화할 수 있습니다. 자세에 유의하며 무리한 움직임은 피하세요.🧘🏻‍♀\n\n잇몸 출혈, 치질, 요실금도 흔하게 나타나지만, 출산 후 자연스레 사라지니 걱정 마세요."
    },
    32: {
      subtext: "[32주차] 여러모로 힘든 몸, 잘 보살펴 주세요.\n\n관절이 늘어나 뚝뚝 소리가 나고, 배는 점점 불러 행동이 서툴러져요. 수분과 영양 섭취는 꼭 챙기고, 역아 체조와 모유수유 준비도 시작해 보세요.\n\n아빠도 체력을 관리하며, 수유 공간과 육아 동참 방법을 함께 고민해 주세요. 부부가 함께 준비하며 공감하는 시간을 가져봐요.🌸"
    },
    33: {
      subtext: "[33주차] 괜찮아요, 흔한 증상이에요.\n\n자궁이 열다섯 배 이상 커졌어요!\n잦은 소변과 요실금, 불면증도 임신 후기의 흔한 증상이랍니다. '심스 자세'로 잠자기, 규칙적 생활, 수분 섭취가 도움이 돼요.\n\n아빠는 엄마가 편히 쉴 수 있도록 집안일도 적극적으로 도와주세요."
    },
    34: {
      subtext: "[34주차] 출산준비로 바쁘다 바빠!\n\n다리에 쥐가 나고 골반 통증이 있을 때는 다리를 조금 높여 쉬고 무리하지 마세요.\n\n지금부터는 출산 가방, 호흡법, 병원 이동 경로도 함께 점검해요.\n\n아기는 뭘하고 있을까요? 몸을 계속 움직여 머리를 자궁 아래로 향해 세상에 나올 준비를 하고 있답니다.🌱"
    },
    35: {
      subtext: "[35주차] 분만호흡법을 연습해요.\n\n분만 시 산소 공급과 통증 완화에 도움 되는 호흡법을 지금부터 미리 연습해두세요.\n\n출산에 대한 두려움은 자연스러운 감정이에요.😣 스스로를 믿고, 너무 스트레스받지 않도록 긍정적으로 생각해 봐요."
    },
    36: {
      subtext: "[36주차] 막달, 결승선을 향해 가고 있어요!\n\n배가 아래로 당기는 느낌이 들고, 몸무게는 최고치에 가까워졌어요.\n\n아기는 지금 태어나도 대부분 안전하지만, 폐 성숙을 위해 조금만 더 기다려요.\n\n아빠는 출산 임박을 주변에 알리고 갑작스런 상황에 대비해주세요. 마지막 한 달, 함께 차분히 준비해봐요.🙂"
    },
    37: {
      subtext: "[37주차] 이제부터는 조산이 아니에요!\n\n언제든 출산이 시작될 수 있어요. 배가 불규칙하게 당기고 점액 분비도 늘어나요. 정기검진으로 자궁경부 상태를 확인해요.\n\n아빠는 아내 곁을 지켜주고, 외출 시에도 연락 가능한 상태를 유지해주세요. 이제 만날 준비, 정말 끝났어요!🤗"
    },
    38: {
      subtext: "[38주차] 긴장을 늦출 수 없는 한 주!\n\n출산가방에 빠진 물건이 없는지 다시 점검해요. 진통 간격 5분, 강한 진통, 양수 파수나 출혈 시 즉시 병원에 가야합니다.\n\n아빠는 불안한 아내에게 큰 힘이 되는 말을 해주세요.\n\n\"걱정 마, 내가 옆에 있어!🫶🏻\""
    },
    39: {
      subtext: "[39주차] 아기 만날 준비 완료! 마지막 점검만 남았어요.\n\n규칙적인 자궁 수축·이슬·양막 파열은 출산 신호예요.\n진통 간격이 짧아지거나 출혈·양수 흐름이 있으면 즉시 병원으로!🚑\n\n곧 아기를 만날 순간이에요. 막판 스퍼트, 아빠도 화이팅!"
    },
    40: {
      subtext: "[40주차] 드디어 만남의 순간!\n\n10개월 여정의 끝이 보이네요. 진통이 규칙적이고 강해지면 병원으로 가세요. 초산인 경우에는 진통이 조금 늦을 수도 있어요.\n\n아빠는 진통 주기 체크와 아내 곁 지키기, 출산 후 아내 상태까지 꼭 살펴주세요.\n\n엄마 아빠 아가 모두, 정말 수고 많았어요!🍀"
    }
  };
  
  export default singleBabyCongratsData;